var _path, _path2, _polygon;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSaveSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m18,19h1V6.83l-1.83-1.83h-1.17v4H7v-4h-2v14h1v-7h12v7ZM4,3h14l2.71,2.71c.19.19.29.44.29.71v13.59c0,.27-.11.52-.29.71-.19.19-.44.29-.71.29H4c-.27,0-.52-.11-.71-.29-.19-.19-.29-.44-.29-.71V4c0-.27.11-.52.29-.71.19-.19.44-.29.71-.29h0Zm4,11v5h8v-5H8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m18.07,23c-2.72,0-4.93-2.21-4.93-4.93s2.21-4.93,4.93-4.93,4.93,2.21,4.93,4.93-2.21,4.93-4.93,4.93Z",
    fill: "#50cd89"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "17.58 20.04 15.48 17.95 16.18 17.25 17.58 18.65 20.37 15.86 21.06 16.55 17.58 20.04",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveSuccess);
export default __webpack_public_path__ + "static/media/save-success.1db04d57de9cc97e1c734463c83888cf.svg";
export { ForwardRef as ReactComponent };